<template>
    <div>
        <ToastNotification/>
        <div class="flex w-full">
            <breeze-sidebar :isEnlarge="isEnlarge"/>
            <div class="min-h-screen bg-gray-100 w-[calc(100vw-257px)]">
                <nav class="bg-gray-100 border-b border-gray-100">
                    <!-- Primary Navigation Menu -->
                    <div class="px-6">
                        <div class="flex justify-between h-12">
                            <div class="flex items-center flex-grow">
                                <div class="relative ">
                                    <breeze-dropdown align="left" width="48" v-if="this.$page.props.allbranches.length">
                                        <template #trigger>
                                            <span class="inline-flex rounded-md" v-if="branchTitle">
                                                <button type="button"
                                                        class="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out bg-white border border-transparent rounded-md hover:text-gray-700 focus:outline-none">
                                                    {{ branchTitle }}

                                                    <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                         viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd"
                                                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                              clip-rule="evenodd"/>
                                                    </svg>
                                                </button>
                                            </span>
                                        </template>

                                        <template #content>
                                            <button
                                                class="block w-full px-4 py-2 text-sm leading-5 text-left text-gray-700 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                                                @click="SelectBranch(branch)" as="button"
                                                v-for="branch,index in this.$page.props.allbranches" :key="index">
                                                {{ branch.title }}
                                            </button>
                                        </template>
                                    </breeze-dropdown>
                                    <button v-else
                                            class="block w-full px-4 py-2 text-sm leading-5 text-left text-gray-700 transition duration-150 ease-in-out bg-white rounded-md focus:outline-none">
                                        {{ branchTitle }}
                                    </button>
                                </div>
                            </div>
                            <div class="flex-grow-0 hidden sm:flex sm:items-center sm:ml-6">
                                <!-- Settings Dropdown -->
                                <div class="relative ml-3">
                                    <breeze-dropdown align="right" width="48">
                                        <template #trigger>
                                            <span class="inline-flex rounded-md">
                                                <button type="button"
                                                        class="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-gray-500 transition duration-150 ease-in-out bg-white border border-transparent rounded-md hover:text-gray-700 focus:outline-none">
                                                    {{ $page.props.auth.user.name }}

                                                    <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                                         viewBox="0 0 20 20" fill="currentColor">
                                                        <path fill-rule="evenodd"
                                                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                              clip-rule="evenodd"/>
                                                    </svg>
                                                </button>
                                            </span>
                                        </template>

                                        <template #content>
                                            <breeze-dropdown-link :href="route('profile')">
                                                Profile
                                            </breeze-dropdown-link>
                                            <breeze-dropdown-link :href="route('logout')" method="post" as="button">
                                                Log Out
                                            </breeze-dropdown-link>
                                        </template>
                                    </breeze-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Responsive Navigation Menu -->
                    <div :class="{'block': showingNavigationDropdown, 'hidden': ! showingNavigationDropdown}"
                         class="sm:hidden">
                        <div class="pt-2 pb-3 space-y-1">
                            <breeze-responsive-nav-link :href="route('dashboard')"
                                                        :active="route().current('dashboard')">
                                Dashboard
                            </breeze-responsive-nav-link>
                        </div>

                        <!-- Responsive Settings Options -->
                        <div class="pt-4 pb-1 border-t border-gray-200">
                            <div class="flex items-center px-4">
                                <div class="text-base font-medium text-gray-800">{{ $page.props.auth.user.name }}</div>
                                <div class="text-sm font-medium text-gray-500">{{ $page.props.auth.user.email }}</div>
                            </div>

                            <div class="mt-3 space-y-1">
                                <breeze-responsive-nav-link :href="route('profile')">
                                    Profile
                                </breeze-responsive-nav-link>
                                <breeze-responsive-nav-link :href="route('logout')" method="post" as="button">
                                    Log Out
                                </breeze-responsive-nav-link>
                            </div>
                        </div>
                    </div>

                </nav>

                <!-- Page Content -->
                <main class="px-6">
                    <BreadcrumbsComponent :pages="pages"/>
                    <slot name="header"/>

                    <slot class="flex-auto"/>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo'
import BreezeDropdown from '@/Components/Dropdown'
import BreezeDropdownLink from '@/Components/DropdownLink'
import BreezeNavLink from '@/Components/NavLink'
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink'
import BreezeSidebar from '@/Layouts/Sidebar'
import ToastNotification from "@/Components/ToastNotification.vue";
import BreadcrumbsComponent from "@/Components/BreadcrumbsComponent.vue";


export default {
    components: {
        BreadcrumbsComponent,
        ToastNotification,
        BreezeApplicationLogo,
        BreezeDropdown,
        BreezeDropdownLink,
        BreezeNavLink,
        BreezeResponsiveNavLink,
        BreezeSidebar
    },
    props: {
        pages: Object,
    },
    data() {
        return {
            showingNavigationDropdown: false,
            isEnlarge: true,
            onLine: navigator.onLine,
            showBackOnline: false,
            branchTitle: localStorage.branchTitle
        }
    },

    methods: {
        toggleSidebar(boolean) {
            localStorage.showingSidebar = boolean
            this.showingSidebar = boolean
        },
        updateOnlineStatus(e) {
            const {
                type
            } = e;
            this.onLine = type === 'online';
        },
        SelectBranch(branch) {
            var nextUrl = window.location.href.replace(localStorage.branchId, branch?.id);
            localStorage.branchTitle = branch.title
            localStorage.branchId = branch?.id
            window.location = nextUrl
        }
    },
    watch: {
        onLine(v) {
            if (v) {
                this.showBackOnline = true;
                this.$toast.success('You are Online. Your internet connection is back');
                setTimeout(() => {
                    this.showBackOnline = false;
                }, 1000);
            } else {
                this.$toast.error('You are Offline. Check your internet connection.');
            }
        }
    },
    mounted() {
        this.showingSidebar = (localStorage.showingSidebar == 'true');
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
    },
    beforeUnmount() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
        if (this.$page.props.allbranches.length > 0 && !localStorage.branchId) {
            localStorage.branchTitle = this.$page.props.allbranches[0].title
            localStorage.branchId = this.$page.props.allbranches[0]?.id
        } else if (this.$page.props.selectedbranch) {
            localStorage.branchTitle = this.$page.props.selectedbranch.title
            localStorage.branchId = this.$page.props.selectedbranch?.id
        }
    }
}
</script>

<style>
.animate-slider {
    /* animation: slider infinite; */
    -webkit-animation: linear infinite;
    -webkit-animation-name: slider;
    -webkit-animation-duration: 5s;
    animation: linear infinite;
    animation-name: slider;
    animation-duration: 2s;
}

@keyframes slider {
    0% {
        left: -20%;
    }
    100% {
        left: 100%;
    }
    /* 100%{
        left: -20%;
    } */
}

@-webkit-keyframes slider {
    0% {
        left: -20%;
    }
    100% {
        left: 100%;
    }
    /* 100%{
        left: -20%;
    } */
}
</style>
